export const initialState = {
    is_loading: true,
    details: {},
    show_alert: {
        show: false,
        type: '',
        msg: ''
    },
    is_resetting_password: false
}